import { DynamicIcon } from '@/components/DynamicIcon'
import { mergeClasses } from '@/helpers/styling'
import { SimpleTooltip } from '@/components/ui-primitives/simple-tooltip'
import { useFormFieldId } from '@/components/ui-primitives/small/form'

type RadioOption = {
  value: string
  label?: string
  icon?: string
}

export function RadioGroup(props: {
  id?: string
  value: string
  onChange: (value: string) => void
  options: RadioOption[]
  iconsOnly?: boolean
}) {
  const defaultId = useFormFieldId()
  return (
    <div id={props.id ?? defaultId}
         role="radiogroup"
         className="flex flex-shrink justify-between bg-gray-100 rounded-sm">
      {props.options.map(option => (
        <RadioItem key={option.value}
                   active={option.value === props.value}
                   onClick={() => props.onChange(option.value)}
                   label={option.label}
                   icon={option.icon}
                   iconOnly={props.iconsOnly}
        />
      ))}

    </div>
  )
}

function RadioItem(props: {
  label?: string
  icon?: string
  active: boolean
  onClick: () => void
  iconOnly?: boolean
}) {
  return (
    <SimpleTooltip tooltip={!props.active && props.iconOnly && props.label}>
      <button type="button"
              role="radio"
              aria-label={props.label}
              onClick={props.onClick}
              className={mergeClasses(
                `
              rounded-sm
              px-3 py-1
              flex flex-grow items-center justify-center
              transition-colors
              `, {
                  "bg-white border border-input !cursor-default": props.active,
                  "text-gray-500 hover:bg-gray-200 hover:text-black": !props.active
                })}>
        {!props.iconOnly && props.label}
        {props.icon && <DynamicIcon icon={props.icon} size="12px" />}
      </button>
    </SimpleTooltip>
  )
}